import * as types from "./types";

const mutations = {
    [types.LOADING_LEAVEREQUEST](state, value) {
        state.loading = value;
    },
    [types.GET_LEAVEREQUEST_LIST](state, leaverequests) {
        state.leaverequests = leaverequests;
    },
    // [types.REMOVE_LEAVEREQUEST](state, id) {        
    //     state.leaverequests = state.leaverequests.filter((x) => x.id !== id);        
    // },
    [types.ADD_LEAVEREQUEST](state, leaverequest) {        
        state.leaverequests.unshift(leaverequest);
    },
    [types.UPDATE_LEAVEREQUEST](state, leaverequest) {        
        const leaverequestIndex = state.leaverequests.findIndex((x) => x.leaveRequestId === leaverequest.id);
        state.leaverequests[leaverequestIndex] = leaverequest;        
    },
    // [types.GET_LEAVEREQUESTBYID](state, leaverequestId) {
    //     state.leaverequestId = leaverequestId;
    // }
    [types.GET_LEAVEREQUEST_EMPLOYEE](state, employee) {
        state.employee = employee;
    },

    [types.APPROVAL_LEAVEREQUEST](state, leaverequest) {

        const leaverequestIndex = state.leaverequests.findIndex((x) => x.leaveRequestId === leaverequest.id);
        state.leaverequests[leaverequestIndex].status = leaverequest.status;       
    },

    [types.GET_LEAVEREQUEST_SUBORDINATES](state, subordinate) {
        state.subordinate = subordinate;
    }
};

export default mutations;